/* eslint-disable no-undef */
<template>
  <!-- Skill 管理区块 -->
  <SkillManagement style="margin-bottom: 30px;" />

  <div class="system-settings-panel">
    <div class="panel-header">
        <h3>系统提示词管理</h3>
        <el-button type="primary" @click="openSystemPromptDialog()">新增提示词</el-button>
    </div>

    <div v-for="group in groupedSystemPrompts" :key="group.title" class="prompt-group-section" style="margin-bottom: 30px;">
        <div class="group-header" style="margin-bottom: 10px; border-bottom: 2px solid #ebeef5; padding-bottom: 5px;">
            <h4 style="margin: 0; color: #409EFF;">{{ group.title }}</h4>
        </div>
        <el-table :data="group.items" stripe style="width: 100%">
            <el-table-column prop="id" label="ID" width="60"></el-table-column>
            <el-table-column prop="name" label="名称" width="180"></el-table-column>
            <el-table-column label="类型" width="150">
                <template #default="scope">
                    <el-tag :type="scope.row.type === 'format_instruction' ? 'warning' : (scope.row.type.startsWith('connector') ? 'success' : (scope.row.type.startsWith('safety') ? 'danger' : 'info'))">
                        {{ promptTypeMap[scope.row.type] || scope.row.type }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="内容预览" show-overflow-tooltip>
                <template #default="scope">
                    {{ scope.row.content.substring(0, 50) }}...
                </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
                <template #default="scope">
                    <el-tag v-if="scope.row.is_active" type="success">生效中</el-tag>
                    <el-tag v-else type="info">未生效</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="updated_at" label="更新时间" width="180">
                 <template #default="scope">
                    {{ new Date(scope.row.updated_at).toLocaleString() }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="250" fixed="right">
                <template #default="scope">
                    <el-button link type="primary" size="small" @click="openSystemPromptDialog(scope.row)">编辑</el-button>
                    <el-button link type="success" size="small" :disabled="scope.row.is_active" @click="setActiveSystemPrompt(scope.row)">设为生效</el-button>
                    <el-button link type="danger" size="small" :disabled="scope.row.is_active" @click="deleteSystemPrompt(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <!-- System Prompt Edit Dialog -->
    <el-dialog v-model="systemPromptDialogVisible" :title="editingSystemPrompt.id ? '编辑系统提示词' : '新增系统提示词'" width="50%">
        <el-form :model="editingSystemPrompt" label-width="80px">
            <el-form-item label="名称">
                <el-input v-model="editingSystemPrompt.name" placeholder="例如: 严谨模式"></el-input>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="editingSystemPrompt.type" placeholder="请选择类型" style="width: 100%">
                    <el-option v-for="(v, k) in promptTypeMap" :key="k" :label="v" :value="k"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="内容">
                <el-input v-model="editingSystemPrompt.content" type="textarea" :rows="15"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="systemPromptDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveSystemPrompt">保存</el-button>
            </span>
        </template>
    </el-dialog>
  </div>

  <!-- AI Model Management -->
  <div class="system-settings-panel" style="margin-top: 30px;">
    <div class="panel-header">
        <h3>AI 模型管理</h3>
        <el-button type="primary" @click="openAIModelDialog()">新增模型</el-button>
    </div>

    <el-table :data="aiModels" stripe style="width: 100%">
        <el-table-column prop="id" label="ID" width="60"></el-table-column>
        <el-table-column prop="name" label="名称" width="180"></el-table-column>
        <el-table-column prop="model_id" label="模型 ID" width="180"></el-table-column>
        <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="100">
            <template #default="scope">
                <el-tag v-if="scope.row.is_active" type="success">启用</el-tag>
                <el-tag v-else type="info">禁用</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="display_order" label="排序" width="80"></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
            <template #default="scope">
                <el-button link type="primary" size="small" @click="openAIModelDialog(scope.row)">编辑</el-button>
                <el-button link type="danger" size="small" @click="deleteAIModel(scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!-- AI Model Edit Dialog -->
    <el-dialog v-model="aiModelDialogVisible" :title="editingAIModel.id ? '编辑模型' : '新增模型'" width="50%">
        <el-form :model="editingAIModel" label-width="100px">
            <el-form-item label="模型名称">
                <el-input v-model="editingAIModel.name" placeholder="例如: DeepSeek V3.2"></el-input>
            </el-form-item>
            <el-form-item label="模型 ID">
                <el-input v-model="editingAIModel.model_id" placeholder="例如: deepseek-v3.2"></el-input>
            </el-form-item>
            <el-form-item label="提供商">
                <el-input v-model="editingAIModel.provider" placeholder="例如: qwen_api"></el-input>
            </el-form-item>
            <el-form-item label="描述">
                <el-input v-model="editingAIModel.description" type="textarea" :rows="3"></el-input>
            </el-form-item>
            <el-form-item label="启用">
                <el-switch v-model="editingAIModel.is_active"></el-switch>
            </el-form-item>
            <el-form-item label="显示顺序">
                <el-input-number v-model="editingAIModel.display_order" :min="0"></el-input-number>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="aiModelDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveAIModel">保存</el-button>
            </span>
        </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
import SkillManagement from './SkillManagement.vue';

defineProps({
  aiModels: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['models-changed']);

// --- System Prompt Management ---
const promptTypeMap = {
    'curator': '策划人设定',
    'format_instruction': '格式指令',
    'connector_requirement': '需求连接语',
    'connector_playlist': '歌曲连接语',
    'connector_user_profile': '画像连接语'
};

const promptGroups = [
    { title: '基础角色 (Curator)', types: ['curator'] },
    { title: '输出格式 (Format)', types: ['format_instruction'] },
    { title: '需求连接 (Connectors)', types: ['connector_requirement', 'connector_playlist', 'connector_user_profile'] }
];

const systemPrompts = ref([]);

const groupedSystemPrompts = computed(() => {
    return promptGroups.map(group => ({
        ...group,
        items: systemPrompts.value.filter(p => group.types.includes(p.type))
    })).filter(group => group.items.length > 0);
});
const systemPromptDialogVisible = ref(false);
const editingSystemPrompt = reactive({
    id: null,
    name: '',
    content: '',
    type: 'curator'
});

const loadSystemPrompts = async () => {
    try {
        const resp = await axios.get('/system/prompt/');
        if (resp.data.code === 1) {
            systemPrompts.value = resp.data.data;
        }
    } catch (err) {
        console.error('Failed to load system prompts', err);
    }
};

const openSystemPromptDialog = (row = null) => {
    if (row) {
        editingSystemPrompt.id = row.id;
        editingSystemPrompt.name = row.name;
        editingSystemPrompt.content = row.content;
        editingSystemPrompt.type = row.type;
    } else {
        editingSystemPrompt.id = null;
        editingSystemPrompt.name = '';
        editingSystemPrompt.content = '';
        editingSystemPrompt.type = 'curator';
    }
    systemPromptDialogVisible.value = true;
};

const saveSystemPrompt = async () => {
    if (!editingSystemPrompt.name || !editingSystemPrompt.content) {
        ElMessage.warning('名称和内容不能为空');
        return;
    }

    try {
        if (editingSystemPrompt.id) {
            // Update
            const resp = await axios.put(`/system/prompt/${editingSystemPrompt.id}`, editingSystemPrompt);
            if (resp.data.code === 1) {
                ElMessage.success('更新成功');
            } else {
                ElMessage.error(resp.data.msg);
            }
        } else {
            // Create
            const resp = await axios.post('/system/prompt/', editingSystemPrompt);
            if (resp.data.code === 1) {
                ElMessage.success('创建成功');
            } else {
                ElMessage.error(resp.data.msg);
            }
        }
        systemPromptDialogVisible.value = false;
        loadSystemPrompts();
    } catch (err) {
        console.error('Failed to save system prompt', err);
        ElMessage.error('保存失败');
    }
};

const deleteSystemPrompt = async (row) => {
    try {
        await  ElMessageBox.confirm(`确定要删除 "${row.name}" 吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        });

        const resp = await axios.delete(`/system/prompt/${row.id}`);
        if (resp.data.code === 1) {
            ElMessage.success('删除成功');
            loadSystemPrompts();
        } else {
            ElMessage.error(resp.data.msg);
        }
    } catch (err) {
        if (err !== 'cancel') {
             console.error('Failed to delete system prompt', err);
             ElMessage.error('删除失败');
        }
    }
};

const setActiveSystemPrompt = async (row) => {
    try {
        const resp = await axios.post(`/system/prompt/${row.id}/active`);
        if (resp.data.code === 1) {
            ElMessage.success('设置成功');
            loadSystemPrompts();
        } else {
            ElMessage.error(resp.data.msg);
        }
    } catch (err) {
        console.error('Failed to set active system prompt', err);
        ElMessage.error('设置失败');
    }
};

// --- AI Model Management ---
const aiModelDialogVisible = ref(false);
const editingAIModel = reactive({
    id: null,
    name: '',
    model_id: '',
    provider: 'qwen_api',
    description: '',
    is_active: true,
    display_order: 0
});

const openAIModelDialog = (row = null) => {
    if (row) {
        Object.assign(editingAIModel, row);
    } else {
        editingAIModel.id = null;
        editingAIModel.name = '';
        editingAIModel.model_id = '';
        editingAIModel.provider = 'qwen_api';
        editingAIModel.description = '';
        editingAIModel.is_active = true;
        editingAIModel.display_order = 0;
    }
    aiModelDialogVisible.value = true;
};

const saveAIModel = async () => {
    if (!editingAIModel.name || !editingAIModel.model_id) {
        ElMessage.warning('名称和模型 ID 不能为空');
        return;
    }

    try {
        if (editingAIModel.id) {
            const resp = await axios.put(`/api/models/${editingAIModel.id}`, editingAIModel);
            if (resp.data.code === 1) {
                ElMessage.success('更新成功');
            } else {
                ElMessage.error(resp.data.msg);
            }
        } else {
            const resp = await axios.post('/api/models', editingAIModel);
            if (resp.data.code === 1) {
                ElMessage.success('创建成功');
            } else {
                ElMessage.error(resp.data.msg);
            }
        }
        aiModelDialogVisible.value = false;
        // Notify parent to reload
        emit('models-changed');
    } catch (err) {
        console.error('Failed to save AI model', err);
        ElMessage.error('保存失败');
    }
};

const deleteAIModel = async (row) => {
    try {
        await ElMessageBox.confirm(`确定要删除模型 "${row.name}" 吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        });

        const resp = await axios.delete(`/api/models/${row.id}`);
        if (resp.data.code === 1) {
            ElMessage.success('删除成功');
            // Notify parent to reload
            emit('models-changed');
        } else {
            ElMessage.error(resp.data.msg);
        }
    } catch (err) {
        if (err !== 'cancel') {
            console.error('Failed to delete AI model', err);
            ElMessage.error('删除失败');
        }
    }
};

onMounted(() => {
    loadSystemPrompts();
});
</script>

<style scoped>
.system-settings-panel .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
</style>
